import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { HeadingRow, OptionsSelectedText, TitleText } from './ConfigurationGroupHeading.styles';

type ConfigurationGroupHeadingProps = {
  minimumSelections: number | undefined;
  maximumSelections: number | undefined;
  numberSelected: number;
  className?: string;
};

export const ConfigurationGroupHeading: FC<ConfigurationGroupHeadingProps> = ({
  minimumSelections,
  maximumSelections,
  numberSelected,
  className,
}) => {
  const { t } = useTranslations();
  return (
    <HeadingRow className={className}>
      <TitleText>{t('spa.package.selectOptions', { noSelections: minimumSelections })}</TitleText>
      {maximumSelections && (
        <OptionsSelectedText>
          {t('spa.package.selectedOptions', {
            selected: numberSelected,
            maximum: maximumSelections,
          })}
        </OptionsSelectedText>
      )}
    </HeadingRow>
  );
};
